<template>
  <div :class="[{'is-loading':ui.loading, 'Widget--editMode':ui.editMode}, 'Widget', config.type]">
    <div
      v-if="hasData"
      class="Widget-header"
    >
      <div class="Widget-title">
        <span class="Widget-name">
          <!--<span v-if="status.isCustom" class="Widget-customSymbol"></span>-->
          {{ config.title }}
          <span
            v-if="status.isCustom"
            class="Widget-customSymbol"
          >Custom
            <!--<span class="Icon Icon-times Widget-ResetToDefualt" @click.prevent="reset"></span>-->
          </span>
        </span>
      </div>

      <ul class="Widget-links">
        <li class="Widget-link">
          <a
            v-if="!ui.editMode"
            @click.prevent="getInitialDataForAutocomplete"
          >
            <span class="Icon Icon-pencil" /> Edit Widget</a>
          <a
            v-else
            @click.prevent="exitEditMode"
          >
            <span class="Widget-cancelAction Icon Icon-times" />Cancel
          </a>
        </li>
      </ul>
    </div>
    <div
      v-if="hasData"
      class="Widget-TableContainer"
    >
      <div class="Widget-content">
        <table class="Table">
          <thead class="Table-header">
            <tr class="Table-row">
              <th v-if="ui.editMode" />
              <th
                v-for="header in config.table.headers"
                :key="header.id"
                class="Table-td"
              >
                <a
                  href="#"
                  @click.prevent="sortColumn(header)"
                >
                  <span class="Table-filterIcon capitalise">{{ header }}</span>
                  <span
                    v-if="config.sortedBy.subject === header && config.sortedBy.order === 'desc' && !customOrderApplied"
                    class="Icon Icon-caret-down"
                  />
                  <span
                    v-else-if="config.sortedBy.subject === header && config.sortedBy.order === 'asc' && !customOrderApplied"
                    class="Icon Icon-caret-up"
                  />
                  <span
                    v-else
                    class="no-filter"
                  />
                </a>
              </th>
              <th
                v-if="ui.editMode"
                class="Table-content--right"
              >
                Remove from widget
              </th>
            </tr>
          </thead>
          <draggable
            v-if="ui.editMode"
            v-model="rows"
            :element="'tbody'"
            :move="changeOrder"
          >
            <tr
              v-for="row in rowsWithoutOptionLabels"
              :key="row.id"
              class="Table-row"
            >
              <td v-if="ui.editMode">
                <a><span class="Icon Icon-bars" /></a>
              </td>
              <td
                v-for="(value, propertyName) in row"
                :key="propertyName"
                class="Table-td"
              >
                <div
                  v-if="propertyName === 'id'"
                  class="Table-content--right"
                >
                  <a
                    href="#"
                    title="Remove item from the widget"
                    @click.prevent="deleteRow(value)"
                  >
                    <span class="WidgetDelete-icon Icon Icon-times" />
                  </a>
                </div>
                <div v-else>
                  <div v-if="propertyName !== 'optionLabel'">
                    <span :class="[getIcon(propertyName), 'Icon']" />
                    <span
                      v-if="propertyName === 'type'"
                      :class="'Tag Tag--' + value"
                      v-html="value"
                    />
                    <span
                      v-else
                      v-html="value"
                    />
                  </div>
                </div>
              </td>
            </tr>
          </draggable>
          <tbody
            v-else-if="noDataToShowWhenFiltered"
            class="Table-content"
          >
            <tr>
              <td colspan="3">
                <div
                  class="Notice Notice--warning"
                  style="margin: 0"
                >
                  <p class="Notice-copy">
                    There is no data available for the applied date filters.
                  </p>
                </div>
              </td>
            </tr>
          </tbody>
          <tbody
            v-else
            class="Table-content"
          >
            <tr
              v-for="(row, index) in rowsWithoutOptionLabelsAndIds"
              :key="index"
              class="Table-row"
            >
              <td
                v-for="(value, propertyName) in row"
                :key="propertyName"
                class="Table-td"
              >
                <span :class="[getIcon(propertyName), 'Icon']" />
                <span
                  v-if="propertyName === 'type'"
                  :class="'Tag Tag--' + value"
                  v-html="$options.filters.commas(value)"
                />
                <span
                  v-else
                  v-html="$options.filters.commas(value)"
                />
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="showAddRows"
          class="Widget-addNew"
        >
          <div
            v-if="noRowsSelect"
            class="Notice Notice--warning"
          >
            No rows Selected
          </div>
          <v-select
            v-model="dataForAutocomplete.selected"
            :debounce="250"
            :options="dataForAutocomplete.options"
            :on-change="addRow"
            :placeholder="copyForLabels('add', config.type)"
            label="optionLabel"
          />
        </div>
      </div>

      <div class="Widget-footer">
        <div
          v-if="!noDataToShowWhenFiltered"
          style="display: inline-block"
        >
          <span
            v-for="(total, index) in totals"
            :key="index"
            class="Widget-count"
          >
            {{ total.value | commas }}
            <small>
              {{ total.title }}
            </small>
          </span>
        </div>
        <div class="u-floatRight">
          <div class="Buttons Buttons--small">
            <a
              v-if="status.isCustom && !noDataToShowWhenFiltered"
              class="Button Button--secondary"
              href="#"
              @click.prevent="reset"
            >
              <span class="icon-reset" /> Reset
            </a>
            <a
              v-if="!ui.editMode"
              :href="viewAllUrl"
              :class="[{'is-loading' : ui.isLoadingViewAll}, 'Button', 'Button--secondary']"
              @click="ui.isLoadingViewAll = true"
            ><span
              class="Icon Icon-eye"
            /> View All</a>
            <a
              v-if="shouldSave"
              class="Button Button--green"
              href="#"
              @click.prevent="save"
            >
              <span class="icon-save" /> Save
            </a>
          </div>
        </div>
      </div>
    </div>
    <component
      :is="vueNoDataTemplate"
      v-else
    />
  </div>
</template>

<script>
import VueDraggable from 'vuedraggable';
import VueSelect from 'vue-select';
import NoResultsInteractions from '../common/no-results-interactions.vue';
import NoResultsTags from '../common/no-tags.vue';
import CommonOperations from '../../../mixins/common-operations';
import LocalCopy from '../../../lang/en.json';

export default {
  components: {
    'no-results-interactions': NoResultsInteractions,
    'no-results-tags': NoResultsTags,
    draggable: VueDraggable,
    'v-select': VueSelect,
  },
  mixins: [CommonOperations],
  props: {
    getDataUrl: {
      type: String,
      required: true,
      default: '',
    },
    saveConfigUrl: {
      type: String,
      required: true,
      default: '',
    },
    vueNoDataTemplate: {
      type: String,
      required: true,
      default: '',
    },
    getDataWithResetConfigUrl: {
      type: String,
      required: true,
      default: '',
    },
    autoCompleteUrl: {
      type: String,
      required: true,
      default: '',
    },
  },
  data() {
    return {
      config: {
        title: '',
        type: '',
        sortedBy: {
          subject: '',
          order: '',
        },
        table: {
          headers: [],
          rowIds: [],
          footer: [],
        },
      },
      rows: [],
      saveRowsEditMode: [],
      totals: [],
      ui: {
        loading: false,
        isLoadingViewAll: false,
        DateOpened: false,
        editMode: false,
        addRowMode: false,
      },
      status: {
        isCustom: false,
        isDirty: false,
      },
      customOrderApplied: false,
      // If there is no data to show after date filter has been applied
      noDataToShowWhenFiltered: false,
      viewAllUrl: '',
      allTimeStudentsCount: 0,
      dataForAutocomplete: {
        selected: null,
        allOptions: [],
        options: [],
      },
      filterData: {
        fromDate: '',
        toDate: '',
      },
    };
  },
  computed: {
    rowsWithoutOptionLabels() {
      const rowsWithoutLabel = [];
      this.rows.forEach((row) => {
        const data = {};
        Object.keys(row)
          .forEach((key) => {
            if (key !== 'optionLabel') {
              data[key] = row[key];
            }
          });
        rowsWithoutLabel.push(data);
      });
      return rowsWithoutLabel;
    },
    rowsWithoutOptionLabelsAndIds() {
      const rowsWithoutLabelAndIds = [];
      this.rows.forEach((row) => {
        const data = {};
        Object.keys(row)
          .forEach((key) => {
            if (key !== 'optionLabel' && key !== 'id') {
              data[key] = row[key];
            }
          });
        rowsWithoutLabelAndIds.push(data);
      });
      return rowsWithoutLabelAndIds;
    },
    hasData() {
      return this.rows.length || this.ui.editMode;
    },
    shouldSave() {
      return this.rows.length && this.status.isDirty;
    },
    datesValidated() {
      return this.filters.date.from && this.filters.date.to;
    },
    showAddRows() {
      return this.ui.editMode && this.rows.length <= 9;
    },
    // Shows check if rows are selected in edit mode
    noRowsSelect() {
      return (this.rows.length <= (0));
    },
  },
  watch: {
    rows() {
      Object.keys(this.totals)
        .forEach((key) => {
          this.totals[key].value = 0;
          this.rows.forEach((row) => {
            Object.keys(row)
              .forEach((rowKey) => {
                if (key === rowKey) {
                  this.totals[key].value += row[rowKey];
                }
              });
          });
        });
    },
  },
  created() {
    // Listen for overall date filters
    this.$bus.$on('filterData', (event) => {
      this.filterData.fromDate = event.fromDate;
      this.filterData.toDate = event.toDate;

      this.getTableData(this.getDataUrl);
    });
  },
  beforeMount() {
    this.getTableData(this.getDataUrl, null);
  },
  methods: {
    copyForLabels(action, widget) {
      return LocalCopy.table[action][widget];
    },
    // Method that is called when you click the Edit button and you get into the widget Edit mode
    getInitialDataForAutocomplete() {
      this.ui.loading = true;
      this.getSearchData()
        .then(() => {
          this.refreshOptions();
          this.ui.editMode = true;
          this.ui.loading = false;
          this.saveRowsEditMode = this.rows.slice();
          this.status.isDirty = false;
        });
    },
    getSearchData() {
      this.dataForAutocomplete.allOptions = [];
      const getDataRequest = this.$_commonOperations_getDataNew(this.autoCompleteUrl, null);
      getDataRequest.then((response) => {
        const rows = response.data;
        rows.forEach((row) => {
          let data = {};
          Object.keys(row)
            .forEach((key) => {
              if (key !== 'url') {
                data[key] = row[key];
              }
              data = this.buildLinks(data, row.url);
            });
          this.dataForAutocomplete.allOptions.push(data);
        });
      })
        .catch(() => {
          this.$_commonOperations_emitMessage(LocalCopy.flashMessage.errors.genericError, 'error');
        });
      return getDataRequest;
    },
    // Method that is called when you exit the Edit Mode without saving
    exitEditMode() {
      this.ui.editMode = false;
      this.rows = this.saveRowsEditMode.slice();
      this.status.isDirty = this.customOrderApplied;
      this.customOrderApplied = false;
    },
    // Method that updates the available options list for autocomplete
    refreshOptions() {
      this.dataForAutocomplete.options = this.getAvailableOptions(this.dataForAutocomplete.allOptions, this.getRowIDs());
      if (document.getElementById('vue-dashboard')
        .getElementsByClassName('clear').length) {
        document.getElementById('vue-dashboard')
          .getElementsByClassName('clear')[0].click();
      }
    },
    // Method that returns a list of available options to be used for autocomplete
    getAvailableOptions(allOptions, removeRowIds) {
      const options = [];
      Object.keys(allOptions)
        .forEach((key) => {
          if (!removeRowIds.includes(allOptions[key].id)) {
            options.push(allOptions[key]);
          }
        });
      return options;
    },
    // Method that removes a row from the widget table by its ID
    deleteRow(rowId) {
      Object.keys(this.rows)
        .forEach((key) => {
          if (typeof this.rows[key] !== 'undefined' && this.rows[key].id === rowId) {
            this.rows.splice(key, 1);
          }
        });
      this.refreshOptions();
      this.status.isDirty = true;
    },
    updateData(eventData) {
      if (this.config.type === eventData.action) {
        this.ui.loading = true;
        this.$_commonOperations_putData(this.saveConfigUrl, {
          obj: { config: eventData.config },
        })
          .then(() => {
            this.ui.loading = false;
            this.$_commonOperations_emitMessage(LocalCopy.flashMessage.save.success, 'info');
            this.status.isDirty = false;
          })
          .catch(() => {
            this.ui.loading = false;
            this.$_commonOperations_emitMessage(LocalCopy.flashMessage.save.failure, 'error');
          });
      }
    },
    // Method that adds a row to the widget table
    addRow(row) {
      if (row !== null) {
        this.status.isDirty = true;
        this.customOrderApplied = true;
        this.rows.push(row);
        this.refreshOptions();
      }
    },
    // Method that is called when rows have been reordered by dragging
    changeOrder() {
      this.status.isCustom = true;
      this.status.isDirty = true;
      this.customOrderApplied = true;
    },
    // Method that is called when rows have been sorted
    sortColumn(subject) {
      if (!this.noDataToShowWhenFiltered) {
        this.config.sortedBy.order = (this.config.sortedBy.order === ''
            || this.config.sortedBy.order === 'desc') ? 'asc' : 'desc';
        this.config.sortedBy.subject = subject;
        //          this.sortColumnData({
        //            order: this.config.sortedBy.order,
        //            subject: this.config.sortedBy.subject,
        //            action: this.config.type,
        //          });
        this.getTableData(this.getDataUrl);
      }
      return false;
    },
    //  reset Data to default
    reset() {
      this.config.isCallback = false;
      this.$_commonOperations_putData(this.getDataWithResetConfigUrl, {
        obj: {
          config: this.config,
          action: this.config.type,
        },
      })
        .then((response) => {
          this.setUpData(response);
        });
    },
    // Method that is called when the users clicks Save button on the widget table
    save() {
      // Reset the sorting order
      if (this.customOrderApplied) {
        this.config.sortedBy.subject = '';
        this.config.sortedBy.order = '';
      }
      if (this.ui.editMode) {
        this.status.isCustom = this.getRowIDs().length;
        this.config.table.rowIds = this.getRowIDs();
        //  this.$bus.$emit('save', {config: this.config, action: this.config.type});
      }
      this.updateData({
        config: this.config,
        action: this.config.type,
      });
      this.ui.editMode = false;
    },
    // extract the row Ids from the rows table
    getRowIDs() {
      const rowIds = [];
      Object.keys(this.rows)
        .forEach((key) => {
          rowIds.push(this.rows[key].id);
        });
      return rowIds;
    },
    getIcon(subject) {
      let iconClass = '';
      switch (subject) {
        case 'students':
          iconClass = 'Icon-user';
          break;
        case 'interactions':
          iconClass = 'Icon-comments';
          break;
        default:
          iconClass = '';
      }
      return iconClass;
    },
    // Get Table Data
    getTableData(url, filters) {
      this.ui.loading = true;
      const sortParams = {
        sortSubject: this.config.sortedBy.subject,
        sortOrder: this.config.sortedBy.order,
        fromDate: this.filterData.fromDate,
        toDate: this.filterData.toDate,
      };
      const params = (typeof filters !== 'undefined')
        ? Object.assign(sortParams, filters) : sortParams;

      this.$_commonOperations_getDataNew(url, { params })
        .then((response) => {
          this.setUpData(response);
        })
        .catch(() => {
          this.ui.loading = false;
          this.$_commonOperations_emitMessage(LocalCopy.flashMessage.errors.genericError, 'error');
        });
    },
    // Setup data after getting data (shared)
    setUpData(response) {
      this.ui.loading = false;
      const {
        config, rows, totals, status, viewAllUrl, allTimeStudentsCount,
      } = response.data;
      if (rows.length === 0) {
        this.noDataToShowWhenFiltered = true;
      } else {
        this.config = config;
        this.totals = totals;
        this.status = status;
        this.viewAllUrl = viewAllUrl;
        this.allTimeStudentsCount = allTimeStudentsCount;
        this.rows = [];
        if (this.allTimeStudentsCount > 0) {
          rows.forEach((row) => {
            let data = {};
            Object.keys(row)
              .forEach((key) => {
                if (key !== 'url') {
                  data[key] = row[key];
                }
              });
            data = this.buildLinks(data, row.url);
            this.rows.push(data);
          });
        }
        this.noDataToShowWhenFiltered = false;
      }
    },
    /**
       * Build links
       * @param row
       * @param url
       * @returns {*}
       */
    buildLinks(row, url) {
      const newRow = row;
      Object.keys(row)
        .forEach((key) => {
          if (key === url.applyTo) {
            const link = document.createElement('a');
            link.href = url.href;
            link.innerHTML = row[key];
            newRow[key] = link.outerHTML;
          }
        });
      return newRow;
    },
  },
};
</script>
